import { Product } from 'types/products';
import { CategoryKey } from './categories';

export enum ProductId {
  UnisexGarmentDyedHeavyweightTShirt = '7ab77b31-f4a6-4fed-98b1-94a4d19948a6',
  RetroTruckerHat = '66d068f9-52bb-478c-b23f-bb9c75734317',
  UnisexTriBlendTShirt = '5e27e855-75da-4b4e-9f2c-62cb9eb4020d',
  WhiteGlossyMug = '20f4e1cc-b4b0-4cf1-9651-1cb248ab0027',
  UnisexHeavyBlendHoodie = 'c73cae26-3c6c-474d-90f3-cf8a088b6747',
  CuffedBeanie = '6e355463-7823-478e-80ff-7aee35379ce3',
  ClassicSnapback = '55eb1aeb-644e-4714-b4e7-e21165981cb1',
  UnisexPremiumSweatshirt = 'fefad013-b3dc-409a-bfb9-582db7008bd1',
  UnisexThreeQuarterSleeveRaglanShirt = 'd38bbb26-c24a-4cc8-a2ec-6cd4e7ef69fd',
  UnisexBasicSoftstyleTShirt = '7da563db-4180-418d-9d47-2464f875e8ce',
  UnisexPremiumHoodie = '4046af19-48e9-4d48-b7eb-14785cc25204',
  UnisexGarmentDyedTankTop = 'ce28ec7a-400f-4288-a4b0-fe67321c4bf9',
  WomensRelaxedTShirt = '43518abd-06d8-4aab-bc6b-2146f947b0b8',
  WomensCropTop = '65cff8ba-4d11-46be-83b6-ff0aa1113ac4',
  UnisexPigmentDyedSweatpants = '15de3573-2d69-4db9-b6cd-3cb0b2edfac6',
  UnisexOrganicCottonTShirt = '1db2ef02-8d99-4843-9c44-1549d72d0d6e',
  UnisexFleeceSweatpants = '3d8df01e-b12e-49b7-a748-e0f5457071c3',
  UnisexStapleTShirt = 'db076ae4-d30b-4dd8-a489-9abd6560da07',
  UnisexOrganicOversizedHighNeckTShirt = '549c32b7-a760-4ee6-8d24-4467625cea7f',
  BabyShortSleeveOnePiece = '053d7c2c-0e8b-47a6-a7d1-8434474864f1',
  YouthHeavyBlendHoodie = '7a4df1a5-df10-4b0f-a5c6-23e6160086aa',
  YouthLongSleeveTee = '8d898bf4-0eac-4619-b905-c1fe4b83a09f',
  KidsFleeceHoodie = '98675bc2-e1f7-4df4-84d2-89aa46d44bf7',
  OrganicCottonKidsTShirt = '984726c0-51bd-4d36-95a6-eaf6fe672dab',
  YouthClassicTee = 'f38cd6c8-fbb8-42ba-b4fe-24d1c15b2146',
  YouthStapleTee = '16e4bc54-f945-4c70-81af-8b187719a7bf',
  BabyStapleTee = '20349727-8c10-4b2b-9f94-0b1aee373130',
  FoamTruckerHat = 'd32ddf2f-fb7d-4cc8-b2e3-a4353b65846b',
  ClosedBackStructuredCap = 'd210f718-d18a-42a5-bfc2-dd80f61407a9',
  FivePanelTruckerCap = '8f3cffe6-0ab7-42cb-a747-9af9806d21d2',
  ClassicDadHat = 'cb495700-8447-4672-aebb-47eca4dbab08',
  KnitBeanie = '720bafed-d25e-4d0e-9f0f-3f1431c123b8',
  OrganicBucketHat = '389b01c8-75a7-407f-b372-33f426c4adb4',
  SublimationSocks = '9cb8f0c9-6092-4358-b235-94bcc5e0f556',
  EmbroideredPatches = 'd8756a35-162f-47fe-9039-3618c4db5f55',
  SetOfPinButtons = '9617df0c-94a4-4723-a356-78beef899657',
  BlackFootSublimatedSocks = 'a0e9b9d9-ade6-45a2-a918-63e6a5f82cfc',
  StainlessSteelWaterBottle = '44025319-8676-474c-918d-02d5462b5dd4',
  EmbroideredCrewSocks = '444e352f-8b60-4836-972f-587673bcd323',
  CanCooler = '72c9cb99-785c-40ee-8677-b960864f0a06',
  LargeEcoTote = 'c52089fa-c30f-46fc-b99a-c3fd463baf50',
}

export const productParamsById: Record<ProductId, Product> = {
  [ProductId.UnisexGarmentDyedHeavyweightTShirt]: {
    name: 'Unisex Garment-Dyed Heavyweight T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_3debc7d3b8304fe38e1cd1ea638d1895~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_4b29d03576704c0eb87dff664fb96959~mv2.png',
  },
  [ProductId.RetroTruckerHat]: {
    name: 'Retro Trucker Hat',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_0d7a820b056a41cd9970f85004fdbd20~mv2.jpg',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_d9bc5a0d4de94940a8a90d40eab970e1~mv2.jpg',
  },
  [ProductId.UnisexTriBlendTShirt]: {
    name: 'Unisex Tri-Blend T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_5049835875f44d8bb3d1dde95a25e30d~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a920c81669cf467f8adffaee62573bdf~mv2.png',
  },
  [ProductId.WhiteGlossyMug]: {
    name: 'White Glossy Mug',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_e61df83fd3134552b258e6c6eb1af5fb~mv2.jpg',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_31dcf4409819479c9912615090d9af03~mv2.jpg',
  },
  [ProductId.UnisexHeavyBlendHoodie]: {
    name: 'Unisex Heavy Blend Hoodie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_de65659f94f340e580671b1bbcd3e9a6~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f572984297534c54bd05a41411350826~mv2.png',
  },
  [ProductId.CuffedBeanie]: {
    name: 'Cuffed Beanie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_196ebdf953f8489ca0c4afea8c5d873a~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_c60f124be3014e38ac2a1debb2f3b8a7~mv2.jpg',
  },
  [ProductId.ClassicSnapback]: {
    name: 'Classic Snapback',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_6d22047220c14cea86794e30bbc49bbf~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_7f0916ad8bec4328a3e673cdcd34c471~mv2.jpg',
  },
  [ProductId.UnisexPremiumSweatshirt]: {
    name: 'Unisex Premium Sweatshirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_f089bb9cd49a42cabff7bfe3cc3cc842~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_402c87d7651a461a998679da36a1302e~mv2.png',
  },
  [ProductId.UnisexThreeQuarterSleeveRaglanShirt]: {
    name: 'Unisex 3/4 Sleeve Raglan Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_d35bda5f3efa4aa2953a96048a0afaee~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_ef21d24083114b9fa1f1aa340f27f255~mv2.jpg',
  },
  [ProductId.UnisexBasicSoftstyleTShirt]: {
    name: 'Unisex Basic Softstyle T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_0f07fdceb22a454198b445dec36b4725~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_34392f7882a444cd874f6ce75ad8865d~mv2.png',
  },
  [ProductId.UnisexPremiumHoodie]: {
    name: 'Unisex Premium Hoodie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_2efddc8e155b41bb9a4a9002fdb2e78f~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_b79557e8000d4ed9890a1df24a23d812~mv2.png',
  },
  [ProductId.UnisexGarmentDyedTankTop]: {
    name: 'Unisex Garment-Dyed Tank Top',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_519ead1d72d04148b58ddf5ee5eeb2ea~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_062bd3e63b6f496cbb0b8c1650a5c453~mv2.png',
  },
  [ProductId.WomensRelaxedTShirt]: {
    name: "Women's Relaxed T-Shirt",
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_669e3b5a98e54654a7daa40235df791d~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_122292f39d3b4bfeb4b7b12a29eba806~mv2.png',
  },
  [ProductId.WomensCropTop]: {
    name: "Women's Crop Top",
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_d31b432eb8ec49f19c8ed4d1384900df~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_22a0f9a1e09a4d98b1a21973049f7c96~mv2.png',
  },
  [ProductId.UnisexPigmentDyedSweatpants]: {
    name: 'Unisex Pigment-Dyed Sweatpants',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_aadf12c8b90d4901b723132d880b4811~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_02ed74065e7b4297b5b2fee20d059696~mv2.jpg',
  },
  [ProductId.UnisexOrganicCottonTShirt]: {
    name: 'Unisex Organic Cotton T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_de6d86448e1143e08f87b588372e7245~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_0af39df010524ba5a16c5753dbdb50c7~mv2.png',
  },
  [ProductId.UnisexFleeceSweatpants]: {
    name: 'Unisex Fleece Sweatpants',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_74f636b635254306ad0892b3660415a5~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_85f9c2952e464b0793af40be0896fd64~mv2.jpg',
  },
  [ProductId.UnisexStapleTShirt]: {
    name: 'Unisex Staple T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_558e2994ad1848edbcef547e59735260~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a4842cd2a7fd49cf9e2d4fbd15433b11~mv2.png',
  },
  [ProductId.UnisexOrganicOversizedHighNeckTShirt]: {
    name: 'Unisex Organic Oversized High Neck T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_8f490edb6d88446baebf1dc58401c44c~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_4704ff0eab9b4216b14f1b668411b88d~mv2.png',
  },
  [ProductId.BabyShortSleeveOnePiece]: {
    name: 'Baby Short Sleeve One Piece',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_35cc97733c764253a9811d05db0badd5~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_838aa111d8de4c71ba336d07eea4b06a~mv2.png',
  },
  [ProductId.YouthHeavyBlendHoodie]: {
    name: 'Youth Heavy Blend Hoodie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_937fa2265932493ba19268a9feb63e9c~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_a6a1d5b062b34a59bc1f9f03da9e10e1~mv2.png',
  },
  [ProductId.YouthLongSleeveTee]: {
    name: 'Youth Long Sleeve Tee',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_66cce6018be0497a8540225e553956c4~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_5d3a1da55a8b4e149f219389ac0918a0~mv2.png',
  },
  [ProductId.KidsFleeceHoodie]: {
    name: 'Kids Fleece Hoodie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_78bf786d71bb4b008940c8c02b7083c8~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_1fc74e31cc2f45d3be1c7aaf1d58ffa3~mv2.png',
  },
  [ProductId.OrganicCottonKidsTShirt]: {
    name: 'Organic Cotton Kids T-Shirt',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_a9b11c66ca7e4c3ca1628386bcd7574e~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_136a5285715248b59d15bd3836dd9615~mv2.png',
  },
  [ProductId.YouthClassicTee]: {
    name: 'Youth Classic Tee',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_6709a7016a224c31b455c8b1dcafd35d~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_314faa3e6ecd4e2ab1bff1b323b3fc7b~mv2.png',
  },
  [ProductId.YouthStapleTee]: {
    name: 'Youth Staple Tee',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_0ac884f44e5d4b49888ec62321d3b98b~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_478c8cad00a449c58b6f2770fe0aff19~mv2.png',
  },
  [ProductId.BabyStapleTee]: {
    name: 'Baby Staple Tee',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_0d65788dcb3847e49543c182f28d26a7~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_51112daed565489a92ae06450642a6f8~mv2.png',
  },
  [ProductId.FoamTruckerHat]: {
    name: 'Foam Trucker Hat',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_3f94c143fc8b4f79bca85024e2bb5d90~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_bab53c75501445cda39d2bde069df77e~mv2.png',
  },
  [ProductId.ClosedBackStructuredCap]: {
    name: 'Closed-Back Structured Cap',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_f072b8fb4ee84f958199ac061ff82bfb~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_b6449dfd1688436c89c730d86447feb5~mv2.png',
  },
  [ProductId.FivePanelTruckerCap]: {
    name: '5 Panel Trucker Cap',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_bcb5df59a4fa4bb19d523bd0741df7e9~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_be2589082b894ae79460c9b0e707450d~mv2.png',
  },
  [ProductId.ClassicDadHat]: {
    name: 'Classic Dad Hat',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_7dc272df9f3e441a98c119148a0119d2~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_97b047b2ff294dc4bdb42b2e6c4a00c5~mv2.png',
  },
  [ProductId.KnitBeanie]: {
    name: 'Knit Beanie',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_32cb91b2468341e9b4497bd2da255f9c~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_44158300ced5406e90b6c325f205f03f~mv2.png',
  },
  [ProductId.OrganicBucketHat]: {
    name: 'Organic Bucket Hat',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_ff6b63a5a813469099193b71ed0273e2~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f919d6a4ec684dda94d46ebf7cfb5725~mv2.png',
  },
  [ProductId.SublimationSocks]: {
    name: 'Sublimation Socks',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_e6deb78a2371488ea06bfd7fb9b7ad81~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f91c9b9bc7fc4fb8b874fef43ef97dbb~mv2.png',
  },
  [ProductId.EmbroideredPatches]: {
    name: 'Embroidered Patches',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_4817ba2044c04157a5e82ad93df50819~mv2.webp',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_8d668aa0fa6f41599d9b1d3952e7254e~mv2.png',
  },
  [ProductId.SetOfPinButtons]: {
    name: 'Set of Pin Buttons',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_14d537ddcaa1494eaa288e63441bfa20~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_f584c073916246b4a29772a122d63a34~mv2.png',
  },
  [ProductId.BlackFootSublimatedSocks]: {
    name: 'Black Foot Sublimated Socks',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_c5e5635d5ef543f8bd21674911b802b4~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_7d6e6fce972b449c9361be316cbfffe0~mv2.png',
  },
  [ProductId.StainlessSteelWaterBottle]: {
    name: 'Stainless Steel Water Bottle',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_5ef4d82386974ef3b96a21b94943b65a~mv2.jpg',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_c3f07c2be6e54b749f79cf9394aaf428~mv2.png',
  },
  [ProductId.EmbroideredCrewSocks]: {
    name: 'Embroidered Crew Socks',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_8418d71939f04c00adc53df3ef664889~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_d1eeb46a0f334892ac342b5c6614659f~mv2.png',
  },
  [ProductId.CanCooler]: {
    name: 'Can Cooler',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_a0b47b84a4344d5cb755c916073842ab~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_2ff285de48fc48cab13c7bbc87ba7b4e~mv2.png',
  },
  [ProductId.LargeEcoTote]: {
    name: 'Large Eco Tote',
    imageUrl: 'https://static.wixstatic.com/media/cd21d3_fe6a23f5983c43538815e39b2832b273~mv2.png',
    mockupImageUrl: 'https://static.wixstatic.com/media/cd21d3_75e1c43a613a46c9b9767e7716d83c18~mv2.png',
  },
};

export const productsByCategory: Record<CategoryKey, ProductId[]> = {
  [CategoryKey.BestSellers]: [
    ProductId.UnisexGarmentDyedHeavyweightTShirt,
    ProductId.RetroTruckerHat,
    ProductId.UnisexTriBlendTShirt,
    ProductId.WhiteGlossyMug,
    ProductId.UnisexHeavyBlendHoodie,
    ProductId.CuffedBeanie,
    ProductId.ClassicSnapback,
    ProductId.UnisexPremiumSweatshirt,
  ],
  [CategoryKey.MensClothing]: [
    ProductId.UnisexGarmentDyedHeavyweightTShirt,
    ProductId.UnisexTriBlendTShirt,
    ProductId.UnisexThreeQuarterSleeveRaglanShirt,
    ProductId.UnisexBasicSoftstyleTShirt,
    ProductId.UnisexPremiumHoodie,
    ProductId.UnisexPremiumSweatshirt,
    ProductId.UnisexHeavyBlendHoodie,
    ProductId.UnisexGarmentDyedTankTop,
  ],
  [CategoryKey.WomensClothing]: [
    ProductId.WomensRelaxedTShirt,
    ProductId.WomensCropTop,
    ProductId.UnisexPigmentDyedSweatpants,
    ProductId.UnisexOrganicCottonTShirt,
    ProductId.UnisexFleeceSweatpants,
    ProductId.UnisexStapleTShirt,
    ProductId.UnisexGarmentDyedTankTop,
    ProductId.UnisexOrganicOversizedHighNeckTShirt,
  ],
  [CategoryKey.KidsClothing]: [
    ProductId.BabyShortSleeveOnePiece,
    ProductId.YouthHeavyBlendHoodie,
    ProductId.YouthLongSleeveTee,
    ProductId.KidsFleeceHoodie,
    ProductId.OrganicCottonKidsTShirt,
    ProductId.YouthClassicTee,
    ProductId.YouthStapleTee,
    ProductId.BabyStapleTee,
  ],
  [CategoryKey.Hats]: [
    ProductId.CuffedBeanie,
    ProductId.FoamTruckerHat,
    ProductId.ClosedBackStructuredCap,
    ProductId.FivePanelTruckerCap,
    ProductId.ClassicDadHat,
    ProductId.KnitBeanie,
    ProductId.RetroTruckerHat,
    ProductId.OrganicBucketHat,
  ],
  [CategoryKey.Accessories]: [
    ProductId.SublimationSocks,
    ProductId.EmbroideredPatches,
    ProductId.SetOfPinButtons,
    ProductId.BlackFootSublimatedSocks,
    ProductId.StainlessSteelWaterBottle,
    ProductId.EmbroideredCrewSocks,
    ProductId.CanCooler,
    ProductId.LargeEcoTote,
  ],
};
